module.exports = __webpack_public_path__ + "img/sun.b48fe08d.gif";